import clsx from "clsx";
import { motion } from "motion/react";
import type { ReactNode } from "react";

type CollapseProps = {
  in: boolean;
  className?: string;
  children: ReactNode;
};

// Flight details card uses its own collapse component, as the one from MUI was causing some issues with the layout.
// Specifically, the MUI Collapse component was not properly calculating the height of the content.
export function Collapse({ in: inProp, className, children }: CollapseProps) {
  return (
    <motion.div
      initial={false}
      animate={{ height: inProp ? "auto" : 0 }}
      className={clsx("overflow-clip", className)}
      aria-hidden={!inProp}
    >
      {children}
    </motion.div>
  );
}
